module.exports = __webpack_public_path__ + "img/715.793e148f.svg";